import { isValidElement, type FC, type ReactNode } from 'react';
import classes from './KeyValueRow.module.scss';

export type KeyValueDataObject = {
    label: string;
    value: ReactNode;
    valueClassName?: string;
};

interface KeyValueRowProps {
    dataObject: KeyValueDataObject;
    compact?: boolean;
    className?: string;
}

/** Проверяет пригодность значения для отображения. */
const isRenderableValue = (value: unknown): value is ReactNode => {
    if (value === null || value === undefined || typeof value === 'boolean') return true;
    if (typeof value === 'string' || typeof value === 'number') return true;
    if (Array.isArray(value)) return value.every(isRenderableValue);

    return isValidElement(value);
};

/** Отображает строку с названием и значением. */
export const KeyValueRow: FC<KeyValueRowProps> = (props) => {
    const { dataObject, compact = false, className = '' } = props;

    const hasValue = dataObject.value !== null
        && dataObject.value !== undefined
        && dataObject.value !== ''
        && dataObject.value !== false
        && isRenderableValue(dataObject.value);

    return (
        <div className={`${classes.row} ${compact
            ? classes.compact
            : ''} ${className}`}>
            <div className={classes.label}>{dataObject.label}:</div>
            <div className={`${classes.value} ${dataObject.valueClassName ?? ''}`}>
                {hasValue
                    ? dataObject.value
                    : (
                        <span className={classes.empty}>Не указано</span>
                    )}
            </div>
        </div>
    );
};
